module.exports = __webpack_public_path__ + "static/media/4.af1d5f6f.jpg";